/**
 * Swagger Interface
 * 数据交换格式: JSON
 *
 * OpenAPI spec version: v2.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import ajax, { AjaxPromise, ExtraFetchParams } from '@ajax';
import * as models from '../model/models';

/* tslint:disable:no-unused-variable member-ordering object-literal-shorthand */

/**
 * @description searchArticleUsingGet参数
 * @property `[keyWord]` keyWord
 * @property `[lastIdOnThePreviousPage]` 上一页的最后一个文章的id，搜索第一页时默认为0
 * @property `[lastScoreOnThePreviousPage]` 上一页的最后一个文章的score，搜索第一页时默认为0
 * @property `[pageSize]` pageSize
 */
export interface ParamssearchArticleUsingGet {
  // queryParams
  /**
   * keyWord
   */
  keyWord?: string;
  /**
   * 上一页的最后一个文章的id，搜索第一页时默认为0
   */
  lastIdOnThePreviousPage?: number;
  /**
   * 上一页的最后一个文章的score，搜索第一页时默认为0
   */
  lastScoreOnThePreviousPage?: number;
  /**
   * pageSize
   */
  pageSize?: number;
}
/**
 * @description searchBarUsingGet参数
 * @property `[keyWord]` keyWord
 */
export interface ParamssearchBarUsingGet {
  // queryParams
  /**
   * keyWord
   */
  keyWord?: string;
}
/**
 * @description searchGlobalUsingGet参数
 * @property `[keyWord]` keyWord
 * @property `[type]` type 搜索页面的Tab类型：USER/GROUP/TEAM/TAG/ARTICLE/QUESTION
 */
export interface ParamssearchGlobalUsingGet {
  // queryParams
  /**
   * keyWord
   */
  keyWord?: string;
  /**
   * type 搜索页面的Tab类型：USER/GROUP/TEAM/TAG/ARTICLE/QUESTION
   */
  type?: string;
}
/**
 * @description searchInitArticleIdUsingGet参数
 * @property `articleId` 已发布文章的id
 */
export interface ParamssearchInitArticleIdUsingGet {
  // pathParams
  /**
   * 已发布文章的id
   */
  articleId: number;
}
/**
 * @description searchPageTabUsingGet参数
 * @property `[keyWord]` keyWord
 * @property `type` 搜索页面的Tab类型：USER/GROUP/TEAM/TAG
 */
export interface ParamssearchPageTabUsingGet {
  // queryParams
  /**
   * keyWord
   */
  keyWord?: string;
  /**
   * 搜索页面的Tab类型：USER/GROUP/TEAM/TAG
   */
  type: string;
}
/**
 * @description searchQuestionUsingGet参数
 * @property `[keyWord]` keyWord
 * @property `[lastIdOnThePreviousPage]` 上一页的最后一个问题的id，搜索第一页时默认为0
 * @property `[lastScoreOnThePreviousPage]` 上一页的最后一个问题的score，搜索第一页时默认为0
 * @property `[pageSize]` pageSize
 */
export interface ParamssearchQuestionUsingGet {
  // queryParams
  /**
   * keyWord
   */
  keyWord?: string;
  /**
   * 上一页的最后一个问题的id，搜索第一页时默认为0
   */
  lastIdOnThePreviousPage?: number;
  /**
   * 上一页的最后一个问题的score，搜索第一页时默认为0
   */
  lastScoreOnThePreviousPage?: number;
  /**
   * pageSize
   */
  pageSize?: number;
}
export class SearchApi {
  protected $basePath = '/community/be'.replace(/\/$/, '');

  public constructor(basePath?: string) {
    if (basePath !== undefined) {
      this.$basePath = basePath.replace(/\/$/, '');
    }
  }

  /**
   * 
   * @summary 搜索页面-文章滚动分页
   * @param params ParamssearchArticleUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableSearchResultSingleArticleInfo
   */
  public searchArticleUsingGet = (
    params: ParamssearchArticleUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableSearchResultSingleArticleInfo> => {
    const path = '/api/search/article';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('keyWord' in params) p.query.keyWord = params.keyWord;
    if ('lastIdOnThePreviousPage' in params)
      p.query.lastIdOnThePreviousPage = params.lastIdOnThePreviousPage;
    if ('lastScoreOnThePreviousPage' in params)
      p.query.lastScoreOnThePreviousPage = params.lastScoreOnThePreviousPage;
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 右上角搜索框
   * @param params ParamssearchBarUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultListGlobalSearchInfoCondition
   */
  public searchBarUsingGet = (
    params: ParamssearchBarUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultListGlobalSearchInfoCondition> => {
    const path = '/api/search/bar';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('keyWord' in params) p.query.keyWord = params.keyWord;
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 全局搜索，可识别搜索类别
   * @param params ParamssearchGlobalUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultNewGlobalSearchCondition
   */
  public searchGlobalUsingGet = (
    params: ParamssearchGlobalUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultNewGlobalSearchCondition> => {
    const path = '/api/search/global';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('keyWord' in params) p.query.keyWord = params.keyWord;
    if ('type' in params) p.query.type = params.type;
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 文章发布后-es手动同步
   * @param params ParamssearchInitArticleIdUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultstring
   */
  public searchInitArticleIdUsingGet = (
    params: ParamssearchInitArticleIdUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultstring> => {
    const path = '/api/search/init/{articleId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.articleId, 'articleId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 文章-es数据初始化
   
   
   * @param opt ajax config
   * @returns models.CommonResultstring
   */
  public searchInitEsArticleUsingGet = (
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultstring> => {
    const path = '/api/search/init/es-article';
    const url = this.$basePath + path;
    const p: any = {};
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 问答-es数据初始化
   
   
   * @param opt ajax config
   * @returns models.CommonResultstring
   */
  public searchInitEsQuestionUsingGet = (
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultstring> => {
    const path = '/api/search/init/es-question';
    const url = this.$basePath + path;
    const p: any = {};
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 搜索页面-用户/圈子/团队/标签
   * @param params ParamssearchPageTabUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultListSearchItemCondition
   */
  public searchPageTabUsingGet = (
    params: ParamssearchPageTabUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultListSearchItemCondition> => {
    const path = '/api/search/page/tab';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('keyWord' in params) p.query.keyWord = params.keyWord;
    if ('type' in params) p.query.type = params.type;
    ajax.check(params.type, 'type');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 搜索页面-问答滚动分页
   * @param params ParamssearchQuestionUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableSearchResultQuestionSimpleInfo
   */
  public searchQuestionUsingGet = (
    params: ParamssearchQuestionUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableSearchResultQuestionSimpleInfo> => {
    const path = '/api/search/question';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('keyWord' in params) p.query.keyWord = params.keyWord;
    if ('lastIdOnThePreviousPage' in params)
      p.query.lastIdOnThePreviousPage = params.lastIdOnThePreviousPage;
    if ('lastScoreOnThePreviousPage' in params)
      p.query.lastScoreOnThePreviousPage = params.lastScoreOnThePreviousPage;
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
}

export default new SearchApi();
